import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Mail, Phone } from "lucide-react";
import { Wordmark } from "./Navbar";

export const Footer = () => (
  <footer className="bg-forest text-cream" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-28">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-gold" data-testid="footer-kicker">
            OneHarvestCo. Benefits
          </p>
          <h2 className="mt-6 font-serif text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl">
            Let&rsquo;s grow something
            <br />
            <span className="italic text-gold">lasting</span> together.
          </h2>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-cream/60" data-testid="footer-legacy-line">
            Trusted, long-term relationships through every season — your success is the only driver of my legacy.
          </p>
          <Link
            to="/contact?type=consultation"
            data-testid="footer-consultation-cta"
            className="group mt-10 inline-flex items-center gap-2 rounded-full border border-gold/60 px-8 py-3 text-sm font-medium text-gold transition-all duration-300 hover:-translate-y-0.5 hover:bg-gold hover:text-forest"
          >
            Request a Consultation
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>

        <div className="lg:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-cream/50">Explore</p>
          <ul className="mt-6 space-y-3 text-sm">
            {[
              ["/individuals", "For Individuals", "footer-link-individuals"],
              ["/employers", "For Employers", "footer-link-employers"],
              ["/about", "About", "footer-link-about"],
              ["/education", "Education", "footer-link-education"],
              ["/faq", "FAQ", "footer-link-faq"],
              ["/contact", "Contact", "footer-link-contact"],
            ].map(([to, label, id]) => (
              <li key={to}>
                <Link to={to} data-testid={id} className="link-underline text-cream/80 transition-colors hover:text-cream">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-cream/50">Reach Out</p>
          <ul className="mt-6 space-y-4 text-sm text-cream/80">
            <li className="flex items-start gap-3" data-testid="footer-location">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
              The Woodlands, Texas — serving individuals &amp; employers in The Woodlands, Houston and surrounding communities
            </li>
            <li className="flex items-start gap-3" data-testid="footer-email">
              <Mail className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
              <a href="mailto:kyle@ohcbenefits.com" className="link-underline" data-testid="footer-email-link">
                kyle@ohcbenefits.com
              </a>
            </li>
            <li className="flex items-start gap-3" data-testid="footer-phone">
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
              <a href="tel:+17137257413" className="link-underline" data-testid="footer-phone-link">
                (713) 725-7413
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-20 flex flex-col gap-4 border-t border-cream/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
        <Wordmark dark />
        <p className="max-w-xl text-xs leading-relaxed text-cream/50" data-testid="footer-disclaimer">
          OneHarvestCo. Benefits is the business name used by Kyle Walker, a licensed Texas
          health insurance agent, and is not itself a licensed insurance agency. All insurance
          business is conducted by Kyle Walker as an individually licensed agent. This website is for educational
          purposes and does not constitute insurance, tax, or legal advice. &copy; {new Date().getFullYear()} OneHarvestCo. Benefits.
        </p>
      </div>
    </div>
  </footer>
);
